import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gutter-y-s3" }

import { useI18n } from 'vue-i18n';
import ListLoadingPlaceholder from '@/components/ListLoadingPlaceholder.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PoolsLoadingPlaceholder',
  setup(__props) {

const { t } = useI18n();
const autoPoolCaptions = [
  {
    caption: t('yieldPool.auto.apy.caption'),
    tooltip: t('yieldPool.auto.apy.tooltip'),
    colClass: 'sm:w-4 xl:col-offset-1',
  },
  {
    caption: t('yieldPool.auto.poolCompound.caption'),
    tooltip: t('yieldPool.auto.poolCompound.tooltip'),
    colClass: 'sm:w-4 lg:w-3',
  },
  {
    caption: t('yieldPool.auto.newRewards.caption'),
    tooltip: t('yieldPool.auto.newRewards.tooltip'),
    colClass: 'sm:w-4 lg:w-3',
  },
];
const manualPoolCaptions = [
  {
    caption: t('yieldPool.manual.apr.caption'),
    tooltip: t('yieldPool.manual.apr.tooltip'),
    colClass: 'sm:w-4 xl:col-offset-1',
  },
  {
    caption: t('yieldPool.manual.totalStake.caption'),
    tooltip: t('yieldPool.manual.totalStake.tooltip'),
    colClass: 'sm:w-4 lg:w-3',
  },
  {
    caption: t('yieldPool.manual.newEarnings.caption'),
    tooltip: t('yieldPool.manual.newEarnings.tooltip'),
    colClass: 'sm:w-4 lg:w-3',
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListLoadingPlaceholder, {
      captions: autoPoolCaptions,
      count: "1"
    }),
    _createVNode(ListLoadingPlaceholder, {
      captions: manualPoolCaptions,
      count: "1"
    })
  ]))
}
}

})